<template>
  <div class="content">
    <div class="container-fluid">
       <div class="row">
        <b-modal
            id="modal-top-add"
            hide-footer
            title="Add House"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Add House</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form
                class="text-left"
                @submit.stop.prevent="handleSubmit(submitAddForm)"
              >
                <b-row no-gutters>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="addData.buildingId"
                      @update:modelValue="
                        (newValue) => (addData.buildingId = newValue)
                      "
                        :options="buildingOptions"
                      :rules="{ required: true }"
                      id="text-building"
                      name="text-building"
                      label="Building"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-building-feedback"
                      validatorName="Building"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <VinputNumber
                      inputType="number"
                      :modelValue="addData.size"
                      @update:modelValue="
                        (newValue) => (addData.size = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-size"
                      name="text-size"
                      label="Size"
                      class="mb-1 mr-sm-2"
                      description="text-size-feedback"
                      validatorName="Size"
                      :step=".01"
                    />
                  </b-col>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <VinputNumber
                      inputType="number"
                      :modelValue="addData.floor"
                      @update:modelValue="
                        (newValue) => (addData.floor = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-floor"
                      name="text-floor"
                      label="Floor"
                      class="mb-1 mr-sm-2"
                      description="text-floor-feedback"
                      validatorName="Floor"
                      :step="1"
                    />
                  </b-col>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="addData.roomNumber"
                      @update:modelValue="
                        (newValue) => (addData.roomNumber = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-roomNumber"
                      name="text-roomNumber"
                      label="Room Number"
                      class="mb-1 mr-sm-2"
                      description="text-roomNumber-feedback"
                      validatorName="Room Number"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="addData.priceOption"
                      @update:modelValue="
                        (newValue) => (addData.priceOption = newValue)
                      "
                        :options="priceOptions"
                      :rules="{ required: true }"
                      id="text-price-options"
                      name="text-price-options"
                      label="Price Options"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-price-options-feedback"
                      validatorName="Price Options"
                    />
                  </b-col>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="addData.rentCurrencyType"
                      @update:modelValue="
                        (newValue) => (addData.rentCurrencyType = newValue)
                      "
                        :options="rentCurrencyTypeOptions"
                      :rules="{ required: true }"
                      id="text-rent-currency-options"
                      name="text-rent-currency-options"
                      label="Rent Currency"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-rent-currency-options-feedback"
                      validatorName="Rent Currency"
                    />
                  </b-col>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.price"
                      @update:modelValue="
                        (newValue) => (addData.price = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-price"
                      name="text-price"
                      label="Price"
                      class="mb-1 mr-sm-2"
                      description="text-price-feedback"
                      validatorName="Price"
                      :step=".01"
                    />
                   </b-col>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputNumber
                      v-if="addData.priceOption === 'PerSquareMeter'"
                      inputType="number"
                      :modelValue="computedPrice"
                      @update:modelValue="
                        (newValue) => (computedPrice = newValue)
                      "
                      :rules="{}"
                      id="text-price"
                      name="text-price"
                      label="Monthly Price"
                      class="mb-1 mr-sm-2"
                      description="text-price-feedback"
                      validatorName="Monthly Price"
                      :step=".01"
                      disabled="disabled"
                    />
                   </b-col>
                    <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="addData.description"
                      @update:modelValue="
                        (newValue) => (addData.description = newValue)
                      "
                      :rules="{}"
                      id="text-description"
                      name="text-description"
                      label="Description"
                      class="mb-1 mr-sm-2"
                      description="text-description-feedback"
                      validatorName="Description"
                    />
                  </b-col>
                    <!-- <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.electricPrice"
                      @update:modelValue="
                        (newValue) => (addData.electricPrice = newValue)
                      "
                      :rules="{  }"
                      id="text-electric-price"
                      name="text-electric-price"
                      label="Electric Bill"
                      class="mb-1 mr-sm-2"
                      description="text-electric-price-feedback"
                      validatorName="Electric Bill"
                      :step=".01"
                    />
                   </b-col>
                     <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.waterPrice"
                      @update:modelValue="
                        (newValue) => (addData.waterPrice = newValue)
                      "
                      :rules="{}"
                      id="text-water-price"
                      name="text-water-price"
                      label="Water Bill"
                      class="mb-1 mr-sm-2"
                      description="text-water-price-feedback"
                      validatorName="Water Bill"
                      :step=".01"
                    />
                   </b-col>
                     <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.parkingPrice"
                      @update:modelValue="
                        (newValue) => (addData.parkingPrice = newValue)
                      "
                      :rules="{}"
                      id="text-parking-price"
                      name="text-parking-price"
                      label="Parking Charges"
                      class="mb-1 mr-sm-2"
                      description="text-parking-price-feedback"
                      validatorName="Parking Charges"
                      :step=".01"
                    />
                   </b-col>
                    <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.internetPrice"
                      @update:modelValue="
                        (newValue) => (addData.internetPrice = newValue)
                      "
                      :rules="{}"
                      id="text-internet-price"
                      name="text-internet-price"
                      label="Internet Cost"
                      class="mb-1 mr-sm-2"
                      description="text-internet-price-feedback"
                      validatorName="Internet Cost"
                      :step=".01"
                    />
                   </b-col>
                    <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.otherPrice"
                      @update:modelValue="
                        (newValue) => (addData.otherPrice = newValue)
                      "
                      :rules="{ }"
                      id="text-other-price"
                      name="text-other-price"
                      label="Other Bills"
                      class="mb-1 mr-sm-2"
                      description="text-internet-price-feedback"
                      validatorName="Other Bills"
                      :step=".01"
                    />
                   </b-col>
                  -->
                  <b-col class="mt-2">
                    <b-button type="submit" variant="primary">Submit</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-modal>
      </div>
      <div class="row">
        <b-modal
            id="modal-top-changePrice"
            hide-footer
            title="Change Price"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Change Price and Bills</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <b-tabs small card>
              <b-tab>
                <template #title>
                  <span style="color: rgb(37, 91, 48) !important; font-size: 15px !important; font-weight: 600 !important;">
                     <span class="mob-title">Change Rent Price</span>
                  </span>
                </template>
                <validation-observer ref="observer" v-slot="{ handleSubmit }">
                  <b-form
                    class="text-left"
                    @submit.stop.prevent="handleSubmit(submitChangePriceForm)"
                  >
                    <b-row no-gutters>
                      <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="addData.priceOption"
                      @update:modelValue="
                        (newValue) => (addData.priceOption = newValue)
                      "
                        :options="priceOptions"
                      :rules="{ required: true }"
                      id="text-price-options"
                      name="text-price-options"
                      label="Price Options"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-price-options-feedback"
                      validatorName="Price Options"
                    />
                  </b-col>
                  <b-col
                        md="12"
                        style="justify-content: center; align-items: center"
                      >
                      <VinputNumber
                          v-if="addData.priceOption === 'PerSquareMeter'"
                          inputType="number"
                          :modelValue="computedPrice"
                          @update:modelValue="
                            (newValue) => (computedPrice = newValue)
                          "
                          :rules="{}"
                          id="text-price"
                          name="text-price"
                          label="Monthly Price"
                          class="mb-1 mr-sm-2"
                          description="text-price-feedback"
                          validatorName="Monthly Price"
                          :step=".01"
                          disabled="disabled"
                        />
                      </b-col>
                      <b-col
                        md="12"
                        style="justify-content: center; align-items: center"
                      >
                      <VinputNumber
                          inputType="number"
                          :modelValue="addData.price"
                          @update:modelValue="
                            (newValue) => (addData.price = newValue)
                          "
                          :rules="{ required: true }"
                          id="text-price"
                          name="text-price"
                          label="Price"
                          class="mb-1 mr-sm-2"
                          description="text-price-feedback"
                          validatorName="Price"
                          :step=".01"
                        />
                      </b-col>
                      <b-col
                        md="12"
                        style="justify-content: center; align-items: center"
                      >
                        <Vinput
                          inputType="date"
                          :modelValue="addData.startDate"
                          @update:modelValue="
                            (newValue) => (addData.startDate = newValue)
                          "
                          :rules="{ required: true }"
                          id="text-startDate"
                          name="text-startDate"
                          label="Start Rent on"
                          class="mb-1 mr-sm-2"
                          description="text-startDate-feedback"
                          validatorName="Start Rent on"
                        />
                    </b-col>
                      <b-col class="mt-2">
                        <b-button type="submit" variant="primary">Submit</b-button>
                      </b-col>
                    </b-row>
                  </b-form>
                </validation-observer>
              </b-tab>
              <b-tab v-if="addData.billAmountOption !== 'none'">
                <template #title>
                  <span style="color: rgb(37, 91, 48) !important; font-size: 15px !important; font-weight: 600 !important;">
                     <span class="mob-title">Add Bills</span>
                  </span>
                </template>
                 <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form
                class="text-left"
                @submit.stop.prevent="handleSubmit(submitChangeBillForm)"
              >
                <b-row no-gutters>
                <template v-if="addData.billAmountOption !== 'BySQM' && addData.billAmountOption !== 'EqualForAllHouse'">
                    <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <template v-if="addData.billAmountOption == 'ByReading'">
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.electricPrice"
                      @update:modelValue="
                        (newValue) => (addData.electricPrice = newValue)
                      "
                      :rules="{  }"
                      id="text-electric-reading"
                      name="text-electric-reading"
                      label="Electric Reading (KWH)"
                      class="mb-1 mr-sm-2"
                      description="text-electric-reading-feedback"
                      validatorName="Electric Reading (KWH)"
                      :step=".01"
                    />
                    </template>
                    <template v-else>
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.electricPrice"
                      @update:modelValue="
                        (newValue) => (addData.electricPrice = newValue)
                      "
                      :rules="{  }"
                      id="text-electric-price"
                      name="text-electric-price"
                      label="Electric Bill"
                      class="mb-1 mr-sm-2"
                      description="text-electric-price-feedback"
                      validatorName="Electric Bill"
                      :step=".01"
                    />
                    </template>
                   </b-col>
                     <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <template v-if="addData.billAmountOption == 'ByReading'">
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.waterPrice"
                      @update:modelValue="
                        (newValue) => (addData.waterPrice = newValue)
                      "
                      :rules="{}"
                      id="text-water-reading"
                      name="text-water-reading"
                      label="Water Reading (Meter Cube)"
                      class="mb-1 mr-sm-2"
                      description="text-water-reading-feedback"
                      validatorName="Water Reading"
                      :step=".01"
                    />
                    </template>
                    <template v-else>
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.waterPrice"
                      @update:modelValue="
                        (newValue) => (addData.waterPrice = newValue)
                      "
                      :rules="{}"
                      id="text-water-price"
                      name="text-water-price"
                      label="Water Bill"
                      class="mb-1 mr-sm-2"
                      description="text-water-price-feedback"
                      validatorName="Water Bill"
                      :step=".01"
                    />
                    </template>
                   </b-col>
                   </template>
                     <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                      >
                      <VinputNumber
                          inputType="number"
                          :modelValue="addData.parkingPrice"
                          @update:modelValue="
                            (newValue) => (addData.parkingPrice = newValue)
                          "
                          :rules="{}"
                          id="text-parking-price"
                          name="text-parking-price"
                          label="Parking Charges"
                          class="mb-1 mr-sm-2"
                          description="text-parking-price-feedback"
                          validatorName="Parking Charges"
                          :step=".01"
                        />
                      </b-col>
                        <b-col
                        md="12"
                        style="justify-content: center; align-items: center"
                      >
                      <VinputNumber
                          inputType="number"
                          :modelValue="addData.internetPrice"
                          @update:modelValue="
                            (newValue) => (addData.internetPrice = newValue)
                          "
                          :rules="{}"
                          id="text-internet-price"
                          name="text-internet-price"
                          label="Internet Cost"
                          class="mb-1 mr-sm-2"
                          description="text-internet-price-feedback"
                          validatorName="Internet Cost"
                          :step=".01"
                        />
                      </b-col>
                        <b-col
                        md="12"
                        style="justify-content: center; align-items: center"
                      >
                      <VinputNumber
                          inputType="number"
                          :modelValue="addData.otherPrice"
                          @update:modelValue="
                            (newValue) => (addData.otherPrice = newValue)
                          "
                          :rules="{ }"
                          id="text-other-price"
                          name="text-other-price"
                          label="Other Bills"
                          class="mb-1 mr-sm-2"
                          description="text-internet-price-feedback"
                          validatorName="Other Bills"
                          :step=".01"
                        />
                      </b-col>
                      <template v-if="addData.billAmountOption !== 'BySQM' && addData.billAmountOption !== 'EqualForAllHouse'">
                      <b-col
                        md="12"
                        style="justify-content: center; align-items: center"
                      >
                        <Vinput
                          inputType="date"
                          :modelValue="addData.startDate"
                          @update:modelValue="
                            (newValue) => (addData.startDate = newValue)
                          "
                          :rules="{ required: true }"
                          id="text-startDate"
                          name="text-startDate"
                          label="Start Bill on"
                          class="mb-1 mr-sm-2"
                          description="text-startDate-feedback"
                          validatorName="Start Bill on"
                        />
                    </b-col>
                    </template>
                      <b-col class="mt-2">
                        <b-button type="submit" variant="primary">Submit</b-button>
                      </b-col>
                    </b-row>
                  </b-form>
                </validation-observer>
              </b-tab>
            </b-tabs>
          </b-modal>
      </div>
      <div class="row">
        <b-modal
            id="modal-top-changeBills"
            hide-footer
            title="Change Bills"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Change Bills</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form
                class="text-left"
                @submit.stop.prevent="handleSubmit(submitChangeBillForm)"
              >
                <b-row no-gutters>
                    <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.electricPrice"
                      @update:modelValue="
                        (newValue) => (addData.electricPrice = newValue)
                      "
                      :rules="{  }"
                      id="text-electric-price"
                      name="text-electric-price"
                      label="Electric Bill"
                      class="mb-1 mr-sm-2"
                      description="text-electric-price-feedback"
                      validatorName="Electric Bill"
                      :step=".01"
                    />
                   </b-col>
                     <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.waterPrice"
                      @update:modelValue="
                        (newValue) => (addData.waterPrice = newValue)
                      "
                      :rules="{}"
                      id="text-water-price"
                      name="text-water-price"
                      label="Water Bill"
                      class="mb-1 mr-sm-2"
                      description="text-water-price-feedback"
                      validatorName="Water Bill"
                      :step=".01"
                    />
                   </b-col>
                     <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.parkingPrice"
                      @update:modelValue="
                        (newValue) => (addData.parkingPrice = newValue)
                      "
                      :rules="{}"
                      id="text-parking-price"
                      name="text-parking-price"
                      label="Parking Charges"
                      class="mb-1 mr-sm-2"
                      description="text-parking-price-feedback"
                      validatorName="Parking Charges"
                      :step=".01"
                    />
                   </b-col>
                    <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.internetPrice"
                      @update:modelValue="
                        (newValue) => (addData.internetPrice = newValue)
                      "
                      :rules="{}"
                      id="text-internet-price"
                      name="text-internet-price"
                      label="Internet Cost"
                      class="mb-1 mr-sm-2"
                      description="text-internet-price-feedback"
                      validatorName="Internet Cost"
                      :step=".01"
                    />
                   </b-col>
                    <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.otherPrice"
                      @update:modelValue="
                        (newValue) => (addData.otherPrice = newValue)
                      "
                      :rules="{ }"
                      id="text-other-price"
                      name="text-other-price"
                      label="Other Bills"
                      class="mb-1 mr-sm-2"
                      description="text-internet-price-feedback"
                      validatorName="Other Bills"
                      :step=".01"
                    />
                   </b-col>
                  <b-col class="mt-2">
                    <b-button type="submit" variant="primary">Submit</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-modal>
      </div>
      <div class="row">
        <b-modal
            id="modal-top-EditHouse"
            hide-footer
            title="Edit House"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Edit House</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form
                class="text-left"
                @submit.stop.prevent="handleSubmit(submitEditForm)"
              >
                <b-row no-gutters>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="selectedHouse.building.buildingId"
                      @update:modelValue="
                        (newValue) => (selectedHouse.building.buildingId = newValue)
                      "
                        :options="buildingOptions"
                      :rules="{ required: true }"
                      id="text-building"
                      name="text-building"
                      label="Building"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-building-feedback"
                      validatorName="Building"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <VinputNumber
                      inputType="number"
                      :modelValue="selectedHouse.size"
                      @update:modelValue="
                        (newValue) => (selectedHouse.size = newValue)
                      "
                      :rules="{}"
                      id="text-size"
                      name="text-size"
                      label="Size"
                      class="mb-1 mr-sm-2"
                      description="text-size-feedback"
                      validatorName="Size"
                      :step=".01"
                    />
                  </b-col>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <VinputNumber
                      inputType="text"
                      :modelValue="selectedHouse.floor"
                      @update:modelValue="
                        (newValue) => (selectedHouse.floor = newValue)
                      "
                      :rules="{}"
                      id="text-floor"
                      name="text-floor"
                      label="Floor"
                      class="mb-1 mr-sm-2"
                      description="text-floor-feedback"
                      validatorName="Floor"
                    />
                  </b-col>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="selectedHouse.roomNumber"
                      @update:modelValue="
                        (newValue) => (selectedHouse.roomNumber = newValue)
                      "
                      :rules="{ }"
                      id="text-roomNumber"
                      name="text-roomNumber"
                      label="Room Number"
                      class="mb-1 mr-sm-2"
                      description="text-roomNumber-feedback"
                      validatorName="Room Number"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="selectedHouse.rentCurrencyType"
                      @update:modelValue="
                        (newValue) => (selectedHouse.rentCurrencyType = newValue)
                      "
                        :options="rentCurrencyTypeOptions"
                      :rules="{ required: true }"
                      id="text-rent-currency-options"
                      name="text-rent-currency-options"
                      label="Rent Currency"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-rent-currency-options-feedback"
                      validatorName="Rent Currency"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="selectedHouse.description"
                      @update:modelValue="
                        (newValue) => (selectedHouse.description = newValue)
                      "
                      :rules="{ }"
                      id="text-description"
                      name="text-description"
                      label="Description"
                      class="mb-1 mr-sm-2"
                      description="text-description-feedback"
                      validatorName="Description"
                    />
                  </b-col>
                  <b-col class="mt-2">
                    <b-button type="submit" variant="primary">Submit</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-modal>
      </div>
      <div class="row">
        <b-modal
            id="modal-top-Details"
            hide-footer
            title="Details"
            content-class="shadow" 
            size="xl"
          >
            <template #modal-header="{ close }">
              <h5>Detail</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <b-row>
              <b-col md="12">
               <b-table-simple
                 :small="true"
                  sticky-header
                  style="max-height: 395px;"
                  striped
                  responsive="sm"
                  hover
                  bordered
                >
                  <b-thead>
                    <b-tr>
                      <b-th colspan="7" style="font-weight: 700;text-align: center !important;">Building Information</b-th>
                    </b-tr>
                      <b-tr style="font-weight: 700;text-align: center !important;">
                      <b-th style="width: 20%">Building Name</b-th>
                      <b-th style="width: 10%">Floor</b-th>
                      <b-th style="width: 10%">Room Number</b-th>
                      <b-th style="width: 15%">Size</b-th>
                      <b-th style="width: 15%">Price Option</b-th>
                      <b-th style="width: 15%">Description</b-th>
                      <b-th style="width: 10%">Status</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr>
                      <b-td>{{selectedHouse.HouseInformation.BuildingName}}</b-td>
                      <b-td>{{selectedHouse.HouseInformation.floor}}</b-td>
                      <b-td>{{selectedHouse.HouseInformation.roomNumber}}</b-td>
                      <b-td>{{selectedHouse.HouseInformation.size}}</b-td>
                      <b-td>{{getOptionPrice(selectedHouse.HouseInformation.priceOption)}}</b-td>
                      <b-td>{{selectedHouse.HouseInformation.description}}</b-td>
                      <b-td>{{getStatus(selectedHouse.HouseInformation.status)}}</b-td>
                    </b-tr>
                  </b-tbody>
               </b-table-simple>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6" v-if="selectedHouse.ContractInformation.length > 0">
                <b-table-simple
                    :small="true"
                    sticky-header
                    style="max-height: 395px;"
                    striped
                    responsive="sm"
                    hover
                    bordered
                  >
                    <b-thead>
                      <b-tr>
                          <b-th colspan="6" style="font-weight: 700;text-align: center !important;">Contracts</b-th>
                      </b-tr>
                      <b-tr>
                        <b-th></b-th>
                        <b-th>Tenant</b-th>
                        <b-th>Tenant Phone No</b-th>
                        <b-th>From</b-th>
                        <b-th>To</b-th>
                        <b-th>Total Payment Recieved</b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr
                        v-for="(contract, index) in selectedHouse.ContractInformation"
                        :key="index"
                      >
                        <b-td>
                          <b-badge v-if="contract.Status == 1" variant="primary">Current</b-badge>
                        </b-td>
                        <b-td>{{contract.TenantFullName}}</b-td>
                        <b-td>{{contract.TenantPhoneNumber}}</b-td>
                        <b-td>{{contract.ContractStartDate}}</b-td>
                        <b-td>{{contract.ContractEndDate}}</b-td>
                        <b-td>{{contract.TotalAmountForThisContract}}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td colspan="5" style="font-weight: 700;text-align: right !important;">Total</b-td>
                        <b-td style="font-weight: 700;">{{selectedHouse.TotalAmountForHouse}}</b-td>
                      </b-tr>
                    </b-tbody>
                </b-table-simple>
              </b-col>
              <b-col md="6">
               <b-table-simple
                  :small="true"
                  sticky-header
                  style="max-height: 395px;"
                  striped
                  responsive="sm"
                  hover
                  bordered
                >
                  <b-thead>
                     <b-tr>
                        <b-th colspan="5" style="font-weight: 700;text-align: center !important;">Price Information</b-th>
                     </b-tr>
                    <b-tr>
                      <b-th style="width: 5%"></b-th>
                      <b-th style="width: 15%">Price Options</b-th>
                      <b-th style="width: 12%">Price</b-th>
                      <b-th style="width: 12%">Created At</b-th>
                      <b-th style="width: 15%">Changed By</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr
                      v-for="(item, index) in selectedHouse.PriceInformation"
                      :key="index"
                    >
                      <b-td>
                         <b-badge v-if="item.Status == 1" variant="primary">Current</b-badge>
                      </b-td>
                      <b-td>{{item.priceOption}}</b-td>
                      <b-td>{{numberWithCommas(item.Price)}}</b-td>
                      <b-td>{{item.CreatedDate}}</b-td>
                      <b-td>{{item.registeredBy}}</b-td>
                    </b-tr>
                  </b-tbody>
               </b-table-simple>
              </b-col>
            </b-row>
             <b-row>
              <b-col md="8" v-if="selectedHouse.houseProperty.length > 0">
                <b-table-simple
                    :small="true"
                    sticky-header
                    style="max-height: 395px;"
                    striped
                    responsive="sm"
                    hover
                    bordered
                  >
                    <b-thead>
                      <b-tr>
                          <b-th colspan="4" style="font-weight: 700;text-align: center !important;">House Property</b-th>
                      </b-tr>
                      <b-tr>
                        <b-th style="width: 12%">Property Name</b-th>
                        <b-th style="width: 12%">Property Status</b-th>
                        <b-th style="width: 12%">Created At</b-th>
                        <b-th>Changed By</b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr
                        v-for="(property, index) in selectedHouse.houseProperty"
                        :key="index"
                      >
                        <b-td>{{property.propertyName}}</b-td>
                        <b-td>{{property.status}}</b-td>
                        <b-td>{{property.createdDate}}</b-td>
                        <b-td>{{property.createdBy}}</b-td>
                      </b-tr>
                    </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8" v-if="selectedHouse.OtherPriceInformation.length > 0">
                <b-table-simple
                    :small="true"
                    sticky-header
                    style="max-height: 395px;"
                    striped
                    responsive="sm"
                    hover
                    bordered
                  >
                    <b-thead>
                      <b-tr>
                          <b-th colspan="7" style="font-weight: 700;text-align: center !important;">Other Bills</b-th>
                      </b-tr>
                      <b-tr>
                        <b-th style="width: 5%"></b-th>
                        <b-th style="width: 12%">Electric Bill</b-th>
                        <b-th style="width: 12%">Water Bill</b-th>
                        <b-th style="width: 17%">Parking Charges</b-th>
                        <b-th style="width: 15%">Internet Cost</b-th>
                        <b-th style="width: 12%">Other Bills</b-th>
                        <b-th style="width: 12%">Created At</b-th>
                        <b-th>Changed By</b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr
                        v-for="(other, index) in selectedHouse.OtherPriceInformation"
                        :key="index"
                      >
                        <b-td>
                          <b-badge v-if="other.Status == 1" variant="primary">Current</b-badge>
                        </b-td>
                        <b-td>{{other.electricPrice}}</b-td>
                        <b-td>{{other.waterPrice}}</b-td>
                        <b-td>{{other.parkingPrice}}</b-td>
                        <b-td>{{other.internetPrice}}</b-td>
                        <b-td>{{other.otherPrice}}</b-td>
                        <b-td>{{other.CreatedDate}}</b-td>
                        <b-td>{{other.registeredBy}}</b-td>
                      </b-tr>
                    </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
        </b-modal>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
          >
             <template slot="header">
              <b-row>
              <b-col lg="8" class="my-1">
                <b-button v-if="modulePermission.create == 1" @click="AddHouse()" class="btn-outline-primary">
                  <b-icon class="text-center" icon="plus"></b-icon> New House
                </b-button>
              </b-col>
             <b-col lg="4" class="my-1">
                  <b-form-group class="mb-0">
                    <b-input-group size="sm">
                      <b-form-input
                        id="filter-input"
                        v-model="filter"
                        type="search"
                        placeholder="Filter"
                      ></b-form-input>

                      <b-input-group-append>
                        <b-button class="btn-secondary" :disabled="!filter" @click="filter = ''"
                          >Clear</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
            <b-table-simple
              :small="true"
              sticky-header
              style="max-height: 395px;"
              striped
              responsive="sm"
              hover
            >
              <b-thead>
                <b-tr>
                  <b-th>No.</b-th>
                  <b-th>Building Name</b-th>
                  <b-th>Floor</b-th>
                  <b-th>Room Number</b-th>
                  <b-th>Size</b-th>
                  <b-th>Price Option</b-th>
                  <b-th>Latest Price</b-th>
                  <b-th>Monthly Price</b-th>
                  <b-th>Other Bills</b-th>
                  <b-th>Status</b-th>
                  <b-th>Created At</b-th>
                  <b-th>Created By</b-th>
                  <b-th sticky-column style="height: 45px;"></b-th>
                </b-tr>
              </b-thead>
                 <template v-if="spinner">
                  <b-tbody class="text-center">
                    <b-tr >
                        <b-td colspan="11" class="text-center" style="display: table-cell">
                          <b-spinner
                          style="height: 3rem; width: 3rem;"
                            variant="warning"
                          ></b-spinner>
                        </b-td>
                      </b-tr>
                  </b-tbody>
                </template>
                <template v-else>
                  <template v-if="filterTable.length === 0">
                  <b-tbody class="text-center">
                      <b-tr>
                        <b-td colspan="13" class="text-center">Nothing found</b-td>
                        <b-td></b-td>
                      </b-tr>
                  </b-tbody>
                  </template>
                  <template v-else>
                     <b-tbody class="text-center">
                  <b-tr
                    v-for="(item, index) in filterTable"
                    :key="item.ID"
                  >
                      <b-td>{{++index}}</b-td>
                      <b-td>{{item.building.buildingName}}</b-td>
                      <b-td>{{item.floor}}</b-td>
                      <b-td>{{item.roomNumber}}</b-td>
                      <b-td>{{item.size}} S.q.m</b-td>
                      <b-td>{{getOptionPrice(item.priceOption)}}</b-td>
                      <b-td>{{numberWithCommas(item.latestPrice)}}</b-td>
                      <b-td>
                        <template v-if="item.priceOption === 'PerSquareMeter'">
                        {{numberWithCommas(item.latestPrice * item.size)}}
                        </template>
                        <template v-else>
                          {{numberWithCommas(item.latestPrice)}}
                        </template>
                      </b-td>
                      <b-td>{{numberWithCommas(item.otherPrice)}}</b-td>
                      <b-td>{{getStatus(item.status)}}</b-td>
                      <b-td>{{item.createdDate}}</b-td>
                       <b-td>{{item.registeredBy}}</b-td>
                      <b-td sticky-column>
                        <b-row>
                          <b-col md="3" class="mb-2">
                            <b-icon icon="eye-fill" class="btn-icon" title="View Detail" @click="ViewDetail(item.houseId)" aria-hidden="true" ></b-icon>
                          </b-col>
                          <b-col md="3" class="mb-2" v-if="modulePermission.update == 1">
                            <b-icon icon="pencil-square" class="btn-icon" title="Edit House" @click="EditHouse(item.houseId)" aria-hidden="true" ></b-icon>
                          </b-col>
                          <b-col md="3" class="mb-2" v-if="modulePermission.update == 1"> 
                            <b-icon icon="currency-dollar" class="btn-icon" title="Change Price"  @click="ChangePrice(item.houseId)" aria-hidden="true"></b-icon>
                          </b-col>
                           <b-col md="3" class="mb-2" v-if="modulePermission.update == 1">
                            <b-icon icon="house-door-fill" class="btn-icon" title="Add House Properties"  @click="AddProperty(item.houseId)" aria-hidden="true"></b-icon>
                          </b-col>
                        </b-row>
                      </b-td>
                  </b-tr>
                     </b-tbody>
                  </template>
                </template>
            </b-table-simple>
            <b-row>
                <b-col md="3">
                  <b-form-group
                    id="fieldset-horizontal"
                    label-cols="8" label-cols-xs="8" label-size="md"
                    label="records per page"
                    label-for="input-horizontal"
                    label-align-xl="right"  
                  >
                  <b-form-select id="input-horizontal" v-model="perPage" :options="pageOptions" @change="changePerPage"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="9">
                  <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows" @page-click="changePage" align="right"></b-pagination>
                </b-col>
            </b-row>
            </card>
        </div>
      </div>
       <div class="row">
        <b-modal
            id="modal-top-AddProperty"
            hide-footer
            title="Add Properties"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Add Properties</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form
                class="text-left"
                @submit.stop.prevent="handleSubmit(submitAddPropertyForm)"
              >
                <b-row no-gutters>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="addProperties.propertyName"
                      @update:modelValue="
                        (newValue) => (addProperties.propertyName = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-propertyName"
                      name="text-propertyName"
                      label="Property Name"
                      class="mb-1 mr-sm-2"
                      description="text-propertyName-feedback"
                      validatorName="Property Name"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="addProperties.status"
                      @update:modelValue="
                        (newValue) => (addProperties.status = newValue)
                      "
                      :options="propertyStatusOptions"
                      :rules="{ required: true }"
                      id="text-propertyStatusOptions-options"
                      name="text-propertyStatusOptions-options"
                      label="Property Status"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-propertyStatusOptions-options-feedback"
                      validatorName="Property Status"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                    v-if="addProperties.status === 'Other'"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="addProperties.otherStatus"
                      @update:modelValue="
                        (newValue) => (addProperties.otherStatus = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-otherStatus"
                      name="text-otherStatus"
                      label="Other Status"
                      class="mb-1 mr-sm-2"
                      description="text-otherStatus-feedback"
                      validatorName="Other Status"
                    />
                  </b-col>
                  <b-col class="mt-2">
                    <b-button type="submit" variant="primary">Submit</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-modal>
      </div>
    </div>
  </div>
</template>
<script>
  import LTable from 'src/components/Table.vue'
  import Card from 'src/components/Cards/Card.vue'
  import Vinput from 'src/components/Inputs/Vinput.vue'
  import VinputNumber from 'src/components/Inputs/VinputNumber.vue'
  import Vselect from 'src/components/Inputs/Vselect.vue'
  export default {
    components: {
      LTable,
      Card,
      Vinput,
      VinputNumber,
      Vselect
    },
    data () {
      return {
        modulePermission: {
          view: 1,
          create: 0,
          update: 0,
          delete: 0
        },
        totalRows: 0,
        currentPage: 1,
        pageOptions: [
          {value: 7, text: 7},
          {value: 10, text: 10},
          {value: 25, text: 25},
          {value: 50, text: 50},
          {value: 100, text: 100}
        ],
        perPage: 7,
        items: [],
        buildingOptions: [],
        priceOptions: [
          {value:"PerSquareMeter", text: "Per Square Meter"},
          {value:"PerMonth", text: "Monthly"}
        ],
        rentCurrencyTypeOptions:[
          {value:"ETB", text:"ETB"},
          {value:"USD", text:"USD"}
        ],
        propertyStatusOptions: [
          {value:"Excellent", text: "Excellent"},
          {value:"Very Good", text: "Very Good"},
          {value:"Good", text: "Good"},
          {value:"Poor", text: "Poor"},
          {value:"Damaged", text: "Damaged"},
          {value: "Other", text: "Other"}
        ],
        addData: {
          size: null,
          floor : "",
          roomNumber: "",
          buildingId: "",
          priceOption: "",
          electricPrice: null,
          waterPrice: null,
          parkingPrice: null,
          internetPrice: null,
          otherPrice: null,
          price: null,
          billAmountOption: "",
          description: "",
          rentCurrencyType: "",
          registeredBy: "",
          startDate: ""
        },
        selectedHouse: {
          houseId: null,
          HouseInformation: {
              floor: 0,
              roomNumber: "",
              registerDate: "",
              status: 0,
              size: "",
              latestPrice: "",
              BuildingName: "",
              description: ""
          },
          ContractInformation: [
              // {
              //     TenantFullName: "",
              //     TenantPhoneNumber: "",
              //     ContractStartDate: "",
              //     ContractEndDate: "",
              //     InitialPayment: 0.0,
              //     Period: 0.0,
              //     TotalAmountForThisContract: 0.0
              // }
          ],
          TotalAmountForHouse: 0.0,
          PriceInformation: [
              // {
              //     Price: 300.0,
              //     CreatedDate: 2023-11-11,
              //     Status: 1
              // }
          ],
          priceChangedNumber: 0,
          OtherPriceInformation: [],
          houseProperty: []
        },
        filter: "",
        spinner: true,
        addProperties:{
          houseId: "",
          propertyName: "",
          status: "",
          otherStatus: "",
          createdBy: sessionStorage.getItem("userID")
        }
      }
    },
     mounted() {
      this.getModules();
      this.getBuildings();
      this.getHouseByOwnerID();
      this.$on("AfterComplete", () => {
        this.getBuildings();
        this.getHouseByOwnerID();
      });
    },
    computed: {
      filterTable() {
        var searchItems = this.items;
        var searchString = this.filter;
        if (searchString === "") {
          return searchItems;
        }
        searchString = searchString.trim().toLowerCase();

        searchItems = searchItems.filter(function (item) {
          if (item.building.buildingName.toLowerCase().indexOf(searchString) !== -1 ||  String(item.floor).toLowerCase().indexOf(searchString) !== -1 || item.roomNumber.toLowerCase().indexOf(searchString) !== -1 ) {
            return item;
          }
        });
        return searchItems;
      },
      computedPrice(){
        if(this.addData.priceOption == "PerSquareMeter"){
          if(this.addData.size !== null && this.addData.price !==null) return this.addData.size * this.addData.price;
          else return null
        }else{
          return null
        }
      }
    },
    methods: {
      getModules(){
        this.$store.dispatch('getModulesPermission', {userId: sessionStorage.getItem("userID")})
          .then(response=>{
              //this.items = response.data;
              var modulesList = response.data.modules;
              var BuildingModule = modulesList.filter(x=>x.name === "House");
              if(BuildingModule !== null){
                this.modulePermission.view = BuildingModule[0].listData;
                this.modulePermission.create = BuildingModule[0].createData;
                this.modulePermission.update = BuildingModule[0].updateData;
                this.modulePermission.delete = BuildingModule[0].deleteData;
              }
          })
          .catch(error=>{
              console.log(error);
          })
      },
      getStatus(status){
        return status == 1 ? "Rented" : "Free";
      },
      numberWithCommas(x) {
        if(x !== null && x !== undefined){
            x = x.toFixed(2);
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
      },
      getBuildings(){
         this.$store.dispatch('getBuildingsByOwnerID',{userId: sessionStorage.getItem("ID")})
        .then(response=>{
            Array.from(response.data).forEach((value) => {
            this.buildingOptions.push({
              value: value.buildingId,
              text: value.buildingName
            });
          });
        })
        .catch(error=>{
            this.$notify({
                title: 'Error',
                text: error.response.data,
                type: 'error'
            })
        })
      },
      getHouseByOwnerID(){
          this.spinner = true;
          this.$store.dispatch('getHouseByOwnerID', {userId: sessionStorage.getItem("ID"), page: this.currentPage, line: this.perPage})
          .then(response=>{
              this.items = response.data.Contents;
              this.totalRows = response.data.totalElements;
             // console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
      },
      changePage(event, page){
        this.spinner = true;
         this.$store.dispatch('getHouseByOwnerID', {userId: sessionStorage.getItem("ID"), page: page, line: this.perPage})
          .then(response=>{
              this.items = response.data.Contents;
              this.totalRows = response.data.totalElements;
             // console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
      },
       changePerPage(event){
          this.spinner = true;
         this.$store.dispatch('getHouseByOwnerID', {userId: sessionStorage.getItem("ID"), page: this.currentPage, line: this.perPage})
          .then(response=>{
              this.items = response.data.Contents;
              this.totalRows = response.data.totalElements;
             // console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
      },
      AddHouse(){
        this.$bvModal.show('modal-top-add');
      },
      submitAddForm(){
        this.$bvModal.msgBoxConfirm('Are you sure you want to submit this form?', {
              title: 'Confirm',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'danger',
              okTitle: 'YES',
              cancelTitle: 'NO',
              bodyClass: 'm-2',
              hideHeaderClose: false,
              centered: false
          })
        .then(value => {
            if(value === true){
             // console.log("this.addData", this.addData);
              this.$store.dispatch('AddHouse', {
                  floor: this.addData.floor,
                  roomNumber: this.addData.roomNumber,
                  size: this.addData.size,
                  buildingId: this.addData.buildingId,
                  price: this.addData.price,
                  priceOption: this.addData.priceOption,
                  rentCurrencyType:this.addData.rentCurrencyType,
                  description: this.addData.description,
                  registeredBy: parseInt(sessionStorage.getItem("userID"))
                })
              .then(response=>{
                  this.$notifications.notify(
                    {
                      message: `<span>House successfully created.</span>`,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'success'
                    })
                    this.$bvModal.hide('modal-top-add');
                    this.clearData();
              })
              .catch(error=>{
                  this.$notifications.notify(
                  {
                    message: error.response.data,
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                  })
              })
            }
        })
        .catch(error=>{
            console.log(error)
        })
      },
      ChangePrice(ID){
        this.selectedHouse.houseId = ID;
        this.addData.billAmountOption = this.items.filter(x=>x.houseId == ID)[0].billAmountOption;
        this.$store.dispatch('getPricesByHouseID', {houseId: ID})
          .then(response=>{
           // console.log("some ", response.data)
            this.addData.price = response.data.price;
            this.addData.priceOption = response.data.priceOption;
            this.addData.size = response.data.size;
          })
          .catch(error=>{
              //this.$notify({
              //    title: 'Error',
              //    text: error.response.data,
              //    type: 'error'
             // })
              console.log("here: ",error);
          })
         this.$store.dispatch('getBillsByHouseID', {houseId: ID})
          .then(response=>{
            if(response.data.length > 0){
             // console.log("some ", response.data)
              this.addData.electricPrice = response.data[0].electricPrice;
              this.addData.waterPrice = response.data[0].waterPrice;
              this.addData.parkingPrice = response.data[0].parkingPrice;
              this.addData.internetPrice = response.data[0].internetPrice;
              this.addData.otherPrice = response.data[0].otherPrice;
              this.addData.startDate = response.data[0].startDate;
            }
            this.$bvModal.show('modal-top-changePrice');
          })
          .catch(error=>{
              //this.$notify({
              //    title: 'Error',
              //    text: error.response.data,
              //    type: 'error'
              //})
              console.log("here",error);
          })
      },
      submitChangePriceForm(){
        this.$bvModal.msgBoxConfirm('Are you sure you want to change price of this form?', {
              title: 'Confirm',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'danger',
              okTitle: 'YES',
              cancelTitle: 'NO',
              bodyClass: 'm-2',
              hideHeaderClose: false,
              centered: false
          })
        .then(value => {
            if(value === true){
              this.$store.dispatch('ChangePrice', {house:{houseId: this.selectedHouse.houseId}, price: this.addData.price, priceOption: this.addData.priceOption, startDate: this.addData.startDate, user:{id: sessionStorage.getItem("userID")}})
              .then(response=>{
                  this.$notifications.notify(
                    {
                      message: `<span>Price Successfully Updated.</span>`,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'success'
                    })
                    this.$bvModal.hide('modal-top-changePrice');
                    this.clearData();
              })
              .catch(error=>{
                this.$notifications.notify(
                    {
                      message: error.response.data,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'danger'
                    })
                  console.log(error);
              })
            }
        })
        .catch(error=>{
            console.log(error)
        })
      },
      ChangeBillsPrice(ID){
        this.selectedHouse.houseId = ID;
        this.$store.dispatch('getBillsByHouseID', {houseId: ID})
          .then(response=>{
            this.addData.electricPrice = response.data[0].electricPrice;
              this.addData.waterPrice = response.data[0].waterPrice;
              this.addData.parkingPrice = response.data[0].parkingPrice;
              this.addData.internetPrice = response.data[0].internetPrice;
              this.addData.otherPrice = response.data[0].otherPrice;
              this.$bvModal.show('modal-top-changeBills');
          })
          .catch(error=>{
              this.$notify({
                  title: 'Error',
                  text: error.response.data,
                  type: 'error'
              })
              // console.log(error);
          })
      },
      submitChangeBillForm(){
        //console.log("some:this", this.addData);
        this.$bvModal.msgBoxConfirm('Are you sure you want to change bills ?', {
              title: 'Confirm',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'danger',
              okTitle: 'YES',
              cancelTitle: 'NO',
              bodyClass: 'm-2',
              hideHeaderClose: false,
              centered: false
          })
        .then(value => {
            if(value === true){
              if(this.addData.billAmountOption === "ByReading"){
                 this.$store.dispatch('ChangeBillsByReading', {user: {id:sessionStorage.getItem("userID")}, houseId: this.selectedHouse.houseId, userId: sessionStorage.getItem("userID"), electricReading: this.addData.electricPrice, waterReading: this.addData.waterPrice, parkingPrice: this.addData.parkingPrice, internetPrice: this.addData.internetPrice, otherPrice: this.addData.otherPrice, startDate:this.addData.startDate})
                  .then(response=>{
                      this.$notifications.notify(
                        {
                          message: `<span>Bills Successfully Updated.</span>`,
                          horizontalAlign: 'center',
                          verticalAlign: 'top',
                          type: 'success'
                        })
                        this.$bvModal.hide('modal-top-changeBills');
                        this.$bvModal.hide('modal-top-changePrice');
                        this.clearData();
                  })
                  .catch(error=>{
                    this.$notifications.notify(
                        {
                          message: error.response.data,
                          horizontalAlign: 'center',
                          verticalAlign: 'top',
                          type: 'danger'
                        })
                      console.log(error);
                  })
              }else if(this.addData.billAmountOption == "BySQM" || this.addData.billAmountOption == "EqualForAllHouse"){
               // console.log("some")
                this.$store.dispatch('ChangeBillsOfInternetAndOther', {user:{id:sessionStorage.getItem("userID")}, houseId: this.selectedHouse.houseId, userId: sessionStorage.getItem("userID"), parkingPrice: this.addData.parkingPrice, internetPrice: this.addData.internetPrice, otherPrice: this.addData.otherPrice, startDate:this.addData.startDate})
                .then(response=>{
                    this.$notifications.notify(
                      {
                        message: `<span>Bills Successfully Updated.</span>`,
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'success'
                      })
                      this.$bvModal.hide('modal-top-changeBills');
                      this.$bvModal.hide('modal-top-changePrice');
                      this.clearData();
                })
                .catch(error=>{
                  this.$notifications.notify(
                      {
                        message: error.response.data,
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'danger'
                      })
                    console.log(error);
                })
              }else{
                this.$store.dispatch('ChangeBills', {user:{id:sessionStorage.getItem("userID")}, house:{houseId: this.selectedHouse.houseId}, electricPrice: this.addData.electricPrice, waterPrice: this.addData.waterPrice, parkingPrice: this.addData.parkingPrice, internetPrice: this.addData.internetPrice, otherPrice: this.addData.otherPrice, startDate:this.addData.startDate})
                .then(response=>{
                    this.$notifications.notify(
                      {
                        message: `<span>Bills Successfully Updated.</span>`,
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'success'
                      })
                     // console.log("repose:", response);
                      this.$bvModal.hide('modal-top-changeBills');
                      this.$bvModal.hide('modal-top-changePrice');
                      this.clearData();
                })
                .catch(error=>{
                   console.log("repose:", error);
                  this.$notifications.notify(
                      {
                        message: error.response.data,
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'danger'
                      })
                    console.log(error);
                })
              }
            }
        })
        .catch(error=>{
            console.log(error)
        })
      },

      AddProperty(ID){
        this.selectedHouse = this.items.filter(item=> item.houseId == ID)[0];
        this.$bvModal.show('modal-top-AddProperty');
      },
      submitAddPropertyForm(){
        this.$bvModal.msgBoxConfirm('Are you sure you want to submit this form?', {
            title: 'Confirm',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            cancelVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            bodyClass: 'm-2',
            hideHeaderClose: false,
            centered: false
        })
        .then(value => {
            if(value === true){
              var JsonData = null;

              if(this.addProperties.otherStatus === "" ){
                JsonData = {
                  houseId: this.selectedHouse.houseId,
                  status: this.addProperties.status,
                  propertyName: this.addProperties.propertyName,
                  createdBy: this.addProperties.createdBy
                }
              }else{
                JsonData = {
                  houseId: this.selectedHouse.houseId,
                  status: this.addProperties.otherStatus,
                  propertyName: this.addProperties.propertyName,
                  createdBy: this.addProperties.createdBy
                }
              }

              this.$store.dispatch('AddProperty', JsonData)
              .then(response=>{
                  this.$notifications.notify(
                    {
                      message: `<span>Property registered successfully.</span>`,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'success'
                    })
                    this.$bvModal.hide('modal-top-AddProperty');
                    this.clearData();
              })
              .catch(error=>{
                console.log(error);
                this.$notifications.notify(
                    {
                      message: error.response.data,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'danger'
                    })
                  console.log(error);
              })
            }
        })
        .catch(error=>{
            console.log(error)
        })
      },
      EditHouse(ID){
        this.selectedHouse = this.items.filter(item=> item.houseId == ID)[0];
        this.$bvModal.show('modal-top-EditHouse');
      },
      submitEditForm(){
        this.$bvModal.msgBoxConfirm('Are you sure you want to submit this form?', {
            title: 'Confirm',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            cancelVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            bodyClass: 'm-2',
            hideHeaderClose: false,
            centered: false
        })
        .then(value => {
            if(value === true){
              var houseUpdate = { building:{
                      buildingId: this.selectedHouse.building.buildingId
                    },
                    size: this.selectedHouse.size,
                    floor: this.selectedHouse.floor,
                    roomNumber: this.selectedHouse.roomNumber,
                    houseId: this.selectedHouse.houseId,
                    rentCurrencyType: this.selectedHouse.rentCurrencyType,
                    description: this.selectedHouse.description
              };
              this.$store.dispatch('EditHouse', houseUpdate)
              .then(response=>{
                  this.$notifications.notify(
                    {
                      message: `<span>The House Successfully Updated.</span>`,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'success'
                    })
                    this.$bvModal.hide('modal-top-EditHouse');
                    this.clearData();
              })
              .catch(error=>{
                console.log(error);
                this.$notifications.notify(
                    {
                      message: error.response.data,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'danger'
                    })
                  console.log(error);
              })
            }
        })
        .catch(error=>{
            console.log(error)
        })
      },
      ViewDetail(ID){
        this.$store.dispatch('GetHouseDetailById', {houseId: ID})
        .then(response=>{
          this.selectedHouse = response.data;
         // console.log("some", response.data);
            this.$bvModal.show('modal-top-Details');
            this.clearData();
        })
        .catch(error=>{
          this.$notifications.notify(
              {
                message: error.response.data,
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'danger'
              })
            console.log(error);
        })
      },
      getOptionPrice(option){
        if(option != undefined){
          if(option === null) return "";
          else {
            var optionList = this.priceOptions.filter(x=>x.value == option);
            if(optionList.length > 0)
              return this.priceOptions.filter(x=>x.value == option)[0].text;
            else
              return "";
          }
        }else{
          return "";
        }
      },
      clearData(){
        this.addData.buildingId = "";
        this.addData.size =null;
        this.addData.roomNumber = "";
        this.addData.floor = "";
        this.addData.price = null;
        this.addData.priceOptions = "";
        this.addData.rentCurrencyType="";
        this.addData.electricPrice = null;
        this.addData.waterPrice = null;
        this.addData.parkingPrice = null;
        this.addData.internetPrice = null;
        this.addData.otherPrice = null;
        this.buildingOptions = [];
        this.$emit('AfterComplete');
        this.addProperties.propertyName="";
        this.addProperties.status="";
        // this.selectedHouse.houseId= null,
        // this.selectedHouse.HouseInformation.floor = 0;
        // this.selectedHouse.HouseInformation.roomNumber = "";
        // this.selectedHouse.HouseInformation.registerDate = ""; 
        // this.selectedHouse.HouseInformation.status = 0; 
        // this.selectedHouse.HouseInformation.size = null; 
        // this.selectedHouse.HouseInformation.latestPrice = null; 
        // this.selectedHouse.HouseInformation.BuildingName = ""; 
        // this.selectedHouse.ContractInformation= [];
        // this.selectedHouse.TotalAmountForHouse= 0.0;
        // this.selectedHouse.PriceInformation= [];
        // this.selectedHouse.priceChangedNumber= 0;
        // this.selectedHouse.OtherPriceInformation= [];
      }
    }
  }
</script>
<style scoped>
.b-table-sticky-column:last-child {
  right: 0;
}
.text-warning {
    color: rgba(240, 206, 13, 0.937) !important;
}
.btn-icon{
  font-size: 27px !important;
  padding: 3px 5px 3px 5px;
  width: 40px;
  color:  rgb(37, 91, 48);
  border: 2px solid rgb(37, 91, 48);
}
.btn-icon:hover,
.btn-icon:focus {
  cursor: pointer;
  background-color: rgb(37, 91, 48) !important;
  color: rgba(240, 206, 13, 0.937) !important;
  border-radius: 4px;
  transition: .4s;
}
</style>